// extracted by mini-css-extract-plugin
module.exports = {"input":"del-profile-modal_input_382H5","inputContainer":"del-profile-modal_inputContainer_3UYt7"};